import {Component, Object3D, Prefab, WonderlandEngine} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {CustomLogTag} from '../classes/Constants.js';
import {Puzzle} from './puzzle.js';
import {DefaultGameRules} from './rules/default-game-rules.js';
import {BoardColor} from './board-object.js';
import {Environment} from './environment.js';
import {Area} from '../enums/Area.js';

export class LevelSelect extends Component {
    static TypeName = 'level-select';
    @property.string('Island Environment')
    islandName = 'Island Environment';

    @property.string('Candyland Environment')
    candylandName = 'Candyland Environment';

    private _levelMap = new Map<Area, string>([
        [Area.Island, 'Area-Island.bin'],
        [Area.Candy, 'Area-Candyland.bin'],
    ]);

    // Singleton
    private static _levelSelectInstance: LevelSelect;
    private _currentLevel: any;
    private _selectedArea: Area = Area.Island;
    private _loadedLevel: Map<Area, Prefab> = new Map<Area, Prefab>();
    static get instance(): LevelSelect {
        return LevelSelect._levelSelectInstance;
    }

    private _currentEnvironment: Environment;
    private _selectedEnvironment = '';

    init() {
        if (LevelSelect._levelSelectInstance) {
            this.engine.log.error(
                CustomLogTag.Game,
                'There can only be one instance of LevelSelect Component'
            );
        }

        LevelSelect._levelSelectInstance = this;
    }

    start(): void {
        this._selectedEnvironment = this.islandName; //this.candylandName;
        this.load();
    }

    colorAcceptable(color: BoardColor): boolean {
        let numColors = 0;
        const myRules = Puzzle.instance.rules as DefaultGameRules;

        if (myRules) {
            numColors = myRules.numberOfFruitColors;
        }
        return this._currentEnvironment.colorAcceptable(color, numColors);
    }

    async load() {
        await this._loadEnvironment(this._selectedEnvironment);
    }

    nextEnvironment() {
        this._currentEnvironment.showNext();
    }

    changeLevelTutorial() {
        this._selectedEnvironment = this.islandName;
        this._selectedArea = Area.Island;
        // do not save the last area in this case
    }

    changeLevelIsland() {
        this._selectedEnvironment = this.islandName;
        this._selectedArea = Area.Island;
        //	LocalStorage.Save(lastAreaKey, Area.Island.ToString());
    }

    changeLevelCandyland() {
        this._selectedEnvironment = this.candylandName;
        this._selectedArea = Area.Candy;
    }

    changeLevel(area: Area) {
        switch (area) {
            // case Area.Arctic:
            // 	ChangeLevelArctic();
            // 	break;
            // case Area.Desert:
            // 	ChangeLevelDesert();
            // 	break;
            // case Area.Forest:
            // 	ChangeLevelForest();
            // 	break;
            case Area.Island:
                this.changeLevelIsland();
                break;
            // case Area.Swamp:
            // 	ChangeLevelSwamp();
            // 	break;
            case Area.Candy:
                this.changeLevelCandyland();
                break;
            // case Area.Moon:
            // 	ChangeLevelMoon();
            // 	break;
            // case Area.WukArea:
            // 	ChangeLevelWuk();
            // 	break;
        }
    }
    private _previousInstance: Object3D | null = null;

    private async _loadEnvironment(environmentName: string) {
        if (this._currentLevel === environmentName) {
            return; // already loaded
        }

        if (!this._loadedLevel.has(this._selectedArea)) {
            const level = await this.engine.loadPrefab(
                this._levelMap.get(this._selectedArea)
            );
            this._loadedLevel.set(this._selectedArea, level);
        }

        const instance = this.engine.scene.instantiate(
            this._loadedLevel.get(this._selectedArea)
        );

        if (this._previousInstance) {
            this._previousInstance.destroy();
        }
        this._previousInstance = instance.root;

        instance.root.parent = this.object;
        this._currentLevel = environmentName;
        this._currentEnvironment = this.object
            .findByNameRecursive(environmentName)[0]
            .getComponent(Environment);
    }
}
